export default {
  svgData: [
    {
      id: "slide2tv1",
      name: "TV",
      label: "slide2tv1"
    },
    {
      id: "slide2easel2",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/eic/design/eic-whats-been-updated.jpg"
      ],
      name: "Easel2",
      label: "slide2easel2"
    },
    {
      id: "slide2easel1",
      name: "Easel1",
      label: "slide2easel1"
    },
    {
      id: "slide2easel3",
      assets: ["SandySprings", "Roswell", "Alpharetta"],
      name: "Easel3",
      label: "slide2easel3"
    },
    {
      id: "slide2avatar1"
    },
    {
      id: "slide2bubble1"
    }
  ],
  slideTitle: "Project Design",
  aboutText: `
    <p class="text-justify help">
    In this space, we hope to help you better understand and visualize the preliminary design for the I-285/I-20 East Interchange Project. You may have seen similar displays like these at our Public Information Open Houses (PIOH) in 2019. There have been little changes since then.
    </p>
    <p class="text-justify help">
    We have consolidated the changes that have occurred since the PIOH as an informational display on the right easel, click the <b><u>What’s Changed</b></u> board to view current changes. The <b><u>Concept Display</b></u>, or roll plot, provides a robust picture of the proposed improvements. The updated <b><u>Visualization Video</b></u> on the screen provides you with an aerial, fly-through view of the proposed project.
    </p>
    <p class="text-justify help">
    Once your tour of the Project Design space is complete, we invite you to visit the next station by clicking on the right arrow or selecting your station of choice from the sidebar on the right.
    </p>
    `,
  helpText: `
    <p class="text-justify help">
    Welcome to the Project Design station. We encourage you to complete the following actions in this space: 
    </p>
    <ul class="text-justify help">
      <li>      
      Click the screen to watch the updated <b><u>Visualization Video</b></u> which will give you an aerial perspective of the proposed project.      
      </li>
      <br>
      <li>
      Review the updated project’s design, or <b><u>Concept Display</b></u>, and search for a location(s) that may be of interest to you along the corridor. Refer to the Legend to help you navigate the concept display. For example, the gray pavement means existing lanes to be retained, the black lanes indicate new pavement, and red lines indicate proposed right-of-way acquisitions.       
      </li>
      <br>
      <li>
      Click the one easel in the space: the <b><u>What’s Changed</b></u> board highlights the changes that have occurred to the project since the last public meeting. 
      </li>
    </ul>
    </br>
    <p class="text-justify help">
    <b>Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> 
    to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> 
    to see this message again after you close it out. To return to the project website, select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i> icon.</b>   
    </p>
    `
};
